import { Toast } from 'primereact/toast';
import { createContext, ReactNode, RefObject, useContext, useMemo, useRef } from 'react';

type ToastContextType = {
  toast: RefObject<Toast>;
};

const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  const toast = useRef<Toast>(null);
  const value = useMemo(() => ({ toast }), [toast]);

  return (
    <ToastContext.Provider value={value}>
      <Toast ref={toast} position="top-center" />
      {children}
    </ToastContext.Provider>
  );
};

export const useToast = () => {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast must be used inside ToastProvider');
  }
  return context.toast;
};
